<script lang="ts">
	import { locale } from '$lib/localization/locale';
	import { message } from '$lib/localization/messages';
	import type { User } from 'firebase/auth';
	import ResendVerificationEmailButton from '$components/ResendVerificationEmailButton.svelte';

	export let user: User;

	let resendMessage: string = '';
	let isLoading: boolean = false;
</script>

<div
	class="flex h-full w-full flex-col justify-between gap-3 rounded border border-primary-200 bg-primary-25 px-4 py-3 text-zinc-900 shadow-sm dark:border-zinc-800 dark:bg-navy-900 dark:text-zinc-200 sm:flex-row sm:items-center"
	role="status"
>
	<div class="min-w-0 flex-1">
		<div class="text-sm font-semibold">
			{message($locale, 'common/EmailVerificationNotice', 'yourEmailIsnTVerified')}
		</div>
		<div class="scroller mt-1 h-8 overflow-y-auto text-xs text-zinc-600 dark:text-zinc-400">
			{isLoading
				? message($locale, 'common/EmailVerificationNotice', 'sendingVerificationEmail')
				: resendMessage ||
					message(
						$locale,
						'common/EmailVerificationNotice',
						'checkYourInboxForTheVerificationLinkOrSend'
					)}
		</div>
	</div>
	<ResendVerificationEmailButton
		{user}
		bind:resendMessage
		bind:isLoading
		showMessage={false}
		buttonClass="h-10 shrink-0 rounded border border-primary-300 bg-primary-25 px-4 text-xs font-semibold text-zinc-900 shadow-sm hover:brightness-95 disabled:cursor-wait disabled:opacity-60 dark:border-zinc-700 dark:bg-navy-900 dark:text-zinc-100 dark:hover:brightness-125"
		containerClass="flex shrink-0 items-center sm:h-full"
	/>
</div>
